import { Component, Input } from '@angular/core';

@Component({
  selector: 'menu-blue',
  templateUrl: './menu-blue.component.html',
  standalone: false,
})
export class MenuBlueComponent {
  @Input() size: number = 24;
  @Input() color: string = 'var(--icon-main-color)';
  @Input() isMobileMenuOpen: boolean = false;
}
